import TabComponent from 'components/CustomerTab/CustomerTab'
import React from 'react'

const ViewTenantComponent = () => {
  return (
    <div><TabComponent /></div>
  )
}

export default ViewTenantComponent